__turbopack_context__.v({
  "container": "styles-module-scss-module__Phlwuq__container",
  "header": "styles-module-scss-module__Phlwuq__header",
  "textBlock": "styles-module-scss-module__Phlwuq__textBlock",
});
